<template>
  <div>
    <span>
      <span>
        <a-dropdown :trigger="['click']" :disabled="false">
          <span class="issue-status edit-status">
            <a-tag :color="ticketStatus[status].color">{{ ticketStatus[status].label }}</a-tag>
            <a-icon class="icon-down" type="down" />
          </span>
          <a-menu slot="overlay">
            <a-menu-item v-for="(item, index) in ticketSolveStatus" :key="index" @click="onChange(item.value)">
              <a-tag :color="item.color">{{ item.label }}</a-tag>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </span>
    <!-- <ticket-status-change-modal ref="ticketStatusChangeModal" /> -->
  </div>
</template>
<script>
import { ticketStatus, ticketSolveStatus } from '@/utils/dictionary';
import { issueUpdateStatus } from '@/api/project/issue';
import { modifyTicketFlag } from '@/api/event/problem';

function grantStatusLabel(status) {
  const color = ticketStatus[status].color;
  const label = ticketStatus[status].label;

  return `<span class="ant-tag ant-tag-${color}">${label}</span>`;
}

export default {
  props: {
    status: {
      type: [String, Number],
      default: null
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    },
    ticketId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      ticketStatus,
      ticketSolveStatus,
      bugStatus: null
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.project_id) || this.project_id;
    }
  },
  methods: {
    onChange(value) {
      this.bugStatus = value;
      this.updateStatusAndComment();
    },
    updateStatusAndComment() {
      const req = {
        'id': this.ticketId,
        'handler': '',
        'maintainer': '',
        'tags': '',
        'level': '',
        'status': '',
        'domain': ''

      };
      if (this.flag === 'staus') {
        req.status = this.bugStatus;
      }
      if (this.flag === 'handler') {
        req.handler = this.bugStatus;
      }
      if (this.flag === 'maintainer') {
        req.maintainer = this.bugStatus;
      }
      if (this.flag === 'tags') {
        req.tags = this.bugStatus;
      }
      if (this.flag === 'level') {
        req.level = this.bugStatus;
      }
      if (this.flag === 'domain') {
        req.domain = this.bugStatus;
      }
      modifyTicketFlag({ req }).then(() => {

      });
    }
  }
};
</script>

  <style lang="less" scoped>
  .issue-status {
    cursor: pointer;
    display: inline-block;
    padding: 2px;
    padding-right: 2px;
    line-height: 22px;
    border-radius: 4px;
    .ant-tag {
      margin-right: 2px;
    }
    .icon-down {
      opacity: 0;
    }
  }

  .edit-status:hover {
    cursor: pointer;
    background-color: #e4e4e4;
    .icon-down {
      opacity: 1;
    }
  }
  </style>

